import { render, staticRenderFns } from "./newUpload.vue?vue&type=template&id=7ed68cb5&scoped=true"
import script from "./newUpload.vue?vue&type=script&lang=js"
export * from "./newUpload.vue?vue&type=script&lang=js"
import style0 from "./newUpload.vue?vue&type=style&index=0&id=7ed68cb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed68cb5",
  null
  
)

export default component.exports